import BaseHTMLColumnStrategy from './BaseHTMLColumnStrategy'

export default function HTMLCompositeColumnsStrategy() {}

HTMLCompositeColumnsStrategy.prototype = new BaseHTMLColumnStrategy();

HTMLCompositeColumnsStrategy.prototype.init = function ( strategies ) {
    this.strategies = strategies;
    this.strategiesNumber = strategies.length;
    
    this.levelsNumber = 1;
    for ( var i = 0; i < this.strategiesNumber; ++i )
        this.levelsNumber = Math.max(this.levelsNumber, this.strategies[i].getLevelsNumber());
    
    return this;
};

HTMLCompositeColumnsStrategy.prototype.getLevelsNumber = function () {
    return this.levelsNumber;
};

HTMLCompositeColumnsStrategy.prototype.addFirstHeaderRowCells = function ( row, levelsNumber ) {
    for ( var i = 0; i < this.strategiesNumber; ++i )
        this.strategies[i].addFirstHeaderRowCells(row, levelsNumber);
};

HTMLCompositeColumnsStrategy.prototype.addSecondHeaderRowCells = function ( row, levelsNumber ) {
    for ( var i = 0; i < this.strategiesNumber; ++i )
        this.strategies[i].addSecondHeaderRowCells(row, levelsNumber);
};

HTMLCompositeColumnsStrategy.prototype.addColumnValueCells = function ( row ) {
    for ( var i = 0; i < this.strategiesNumber; ++i )
        this.strategies[i].addColumnValueCells(row);
};




// WEBPACK FOOTER //
// ./web/js/reports/preview/html/billingsummary/HTMLCompositeColumnsStrategy.js